// In src/components/GroupPostForm.js

import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { db } from '../services/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { Box, TextField, Button, CircularProgress } from '@mui/material';

function GroupPostForm({ groupId }) {
  const { currentUser, userProfile } = useAuth();
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (text.trim() === '') return;

    setLoading(true);
    const postsColRef = collection(db, 'churches', userProfile.churchId, 'groups', groupId, 'groupAnnouncements');

    try {
      await addDoc(postsColRef, {
        text,
        authorId: currentUser.uid,
        authorName: `${userProfile.firstName} ${userProfile.lastName}`,
        createdAt: serverTimestamp(),
      });
      setText(''); // Clear the form on success
    } catch (error) {
      console.error("Error creating post:", error);
      alert("Failed to create post.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
      <TextField
        label="Post an announcement to the group wall..."
        fullWidth
        multiline
        rows={3}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <Button type="submit" variant="contained" disabled={loading} sx={{ alignSelf: 'flex-end' }}>
        {loading ? <CircularProgress size={24} /> : 'Post to Wall'}
      </Button>
    </Box>
  );
}

export default GroupPostForm;
